import React from 'react'
import PropTypes from 'prop-types'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import Breadcrumbs from './../block/Breadcrumbs'
import WhiteBlockTitle from './../block/WhiteBlockTitle'
import GreenButton from './../block/GreenButton'
import UslugiLastCard from './../block/UslugiLastCard'
import Kontakti from './../block/Kontakti'
import ClientOnlyFsLightbox from './../block/ClientOnlyFsLightbox'

import styles from './../style/Stati.module.scss'

import { Container, Image } from 'react-bootstrap'

class Stati extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      lightboxController: {
        toggler: false,
        slide: 1
      },
      vkLightboxController: {
        toggler: false,
        slide: 1
      },
      vkPhotos: [],
      activeVideo: null,
      activePost: null
    }
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  // Функция для открытия лайтбокса статей
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  // Функция для открытия лайтбокса VK фото
  openVkPhotoLightbox = (photos, index) => {
    this.setState({
      vkPhotos: photos,
      vkLightboxController: {
        toggler: !this.state.vkLightboxController.toggler,
        slide: index + 1
      }
    })
  }

  // Функция для открытия видео
  openVideo = (videoUrl) => {
    this.setState({ activeVideo: videoUrl })
  }

  // Закрытие видео
  closeVideo = () => {
    this.setState({ activeVideo: null })
  }

  // Открытие модального окна поста
  openPostModal = (post) => {
    this.setState({ activePost: post })
  }

  // Закрытие модального окна поста
  closePostModal = () => {
    this.setState({ activePost: null })
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  // Форматирование длительности видео (секунды -> MM:SS)
  formatDuration = (seconds) => {
    if (!seconds) return '00:00'
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`
  }

  // Форматирование даты
  formatDate = (dateStr) => {
    if (!dateStr) return ''
    const d = new Date(dateStr)
    const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`
  }

  // Обрезка текста
  truncateText = (text, maxLen = 200) => {
    if (!text) return ''
    if (text.length <= maxLen) return text
    return text.substring(0, maxLen) + '...'
  }

  render() {

    const { data, protocol, assets_path } = this.props
    const { lightboxController, vkLightboxController, vkPhotos, activeVideo, activePost } = this.state

    // Собираем все фото из VK постов для лайтбокса
    const allVkPhotos = []
    if (data?.vkwall) {
      data.vkwall.forEach(post => {
        post.attachments.forEach(att => {
          if (att.type === 'photo' && att.preview) {
            allVkPhotos.push(att.preview)
          }
        })
      })
    }

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <Container>
          <div className={styles.section}>
            {/* Lightbox компонент для статей */}
            <ClientOnlyFsLightbox
              toggler={lightboxController.toggler}
              sources={data?.list.map(item => item.full || item.image)}
              slide={lightboxController.slide}
            />

            {/* Lightbox компонент для VK фото */}
            <ClientOnlyFsLightbox
              toggler={vkLightboxController.toggler}
              sources={vkPhotos.length > 0 ? vkPhotos : allVkPhotos}
              slide={vkLightboxController.slide}
            />

            {/* VK Стена */}
            {data?.vkwall && data.vkwall.length > 0 && (
              <div className={styles.vk_section}>
                <WhiteBlockTitle
                  title={'Goodwin Окна-Порталы-Входные двери'}
                  text={``}
                />
                <div className={styles.vk_wall}>
                  {data.vkwall.map((post, postIndex) => {
                    // Собираем фото этого поста для слайдера
                    const postPhotos = post.attachments.filter(att => att.type === 'photo' && att.preview)
                    // Вложения, которые не ушли в слайдер (не фото или фото, но их меньше 2)
                    const visibleAttachments = post.attachments.filter(att => !(att.type === 'photo' && postPhotos.length > 1))
                    return (
                    <div
                      key={post.id}
                      className={`${styles.vk_post} ${post.is_pinned ? styles.vk_post_pinned : ''}`}
                      onClick={() => this.openPostModal(post)}
                      style={{cursor: 'pointer'}}
                    >
                      {/* Дата и закрепление */}
                      <div className={styles.vk_post_date}>
                        <span>{this.formatDate(post.date)}</span>
                        {post.is_pinned && (
                          <span className={styles.vk_pin_badge}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16 12V4H17V2H7V4H8V12L6 14V16H11.2V22H12.8V16H18V14L16 12Z" fill="currentColor"/>
                            </svg>
                            Закреплено
                          </span>
                        )}
                      </div>

                      {/* Вложения — фото/видео выше текста */}
                      {visibleAttachments.length > 0 && (
                        <div className={styles.vk_attachments}>
                          {post.attachments.map((att, attIndex) => {
                            // Если фото 2+ — пропускаем их, они будут в слайдере
                            if (att.type === 'photo' && postPhotos.length > 1) return null
                            return (
                            <div key={attIndex} className={styles.vk_attachment}>
                              {/* Видео */}
                              {(att.type === 'video' || att.type === 'short_video') && (
                                <div
                                  className={styles.vk_video_wrapper}
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    this.openVideo(att.player_url)
                                  }}
                                >
                                  <Image
                                    className={styles.vk_video_preview}
                                    src={att.preview || att.first_frame}
                                    alt={att.title || 'Видео'}
                                    width={400}
                                    height={225}
                                  />
                                  <div className={styles.vk_video_overlay}>
                                    <div className={styles.vk_video_play_btn}>
                                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="24" fill="rgba(0,0,0,0.6)"/>
                                        <path d="M20 16L32 24L20 32V16Z" fill="white"/>
                                      </svg>
                                    </div>
                                    <div className={styles.vk_video_info}>
                                      <span className={styles.vk_video_title}>{att.title || 'Видео'}</span>
                                      <span className={styles.vk_video_meta}>
                                        {this.formatDuration(att.duration)}
                                        {att.views > 0 && ` · ${att.views} просмотров`}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Фото — если в посте 1 фото, показываем как есть */}
                              {att.type === 'photo' && att.preview && postPhotos.length === 1 && (
                                <div className={styles.vk_photo_wrapper}>
                                  <Image
                                    className={styles.vk_photo}
                                    src={att.preview}
                                    alt="Фото"
                                    width={400}
                                    height={300}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      this.openVkPhotoLightbox(allVkPhotos, allVkPhotos.indexOf(att.preview))
                                    }}
                                    style={{cursor: 'pointer'}}
                                  />
                                </div>
                              )}

                              {/* Ссылка */}
                              {att.type === 'link' && (
                                <a
                                  href={att.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={styles.vk_link}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {att.preview && (
                                    <Image
                                      className={styles.vk_link_image}
                                      src={att.preview}
                                      alt={att.title || 'Ссылка'}
                                      width={200}
                                      height={150}
                                    />
                                  )}
                                  <div className={styles.vk_link_content}>
                                    <div className={styles.vk_link_title}>{att.title || ''}</div>
                                    <div className={styles.vk_link_desc}>{att.description || ''}</div>
                                  </div>
                                </a>
                              )}
                            </div>
                            )
                          })}
                        </div>
                      )}

                      {/* Слайдер фото — если в посте 2+ фото */}
                      {postPhotos.length > 1 && (
                        <div className={styles.vk_photo_slider_wrapper}>
                          <Swiper
                            modules={[Navigation]}
                            spaceBetween={8}
                            slidesPerView={1}
                            loop={postPhotos.length > 1}
                            navigation={{
                              prevEl: `.vk-photo-prev-${postIndex}`,
                              nextEl: `.vk-photo-next-${postIndex}`,
                            }}
                            onSlideChange={(swiper) => {
                              const counter = document.querySelector(`.vk-photo-counter-${postIndex}`)
                              if (counter) {
                                counter.textContent = swiper.realIndex + 1
                              }
                            }}
                          >
                            {postPhotos.map((photo, photoIndex) => (
                              <SwiperSlide key={photoIndex}>
                                <div className={styles.vk_photo_slide}>
                                  <Image
                                    className={styles.vk_photo_slide_img}
                                    src={photo.preview}
                                    alt="Фото"
                                    width={400}
                                    height={300}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      this.openVkPhotoLightbox(allVkPhotos, allVkPhotos.indexOf(photo.preview))
                                    }}
                                    style={{cursor: 'pointer'}}
                                  />
                                </div>
                              </SwiperSlide>
                            ))}
                            {/* Кастомная навигация */}
                            <div className={styles.vk_photo_slider_nav} onClick={(e) => e.stopPropagation()}>
                              <div className={`${styles.vk_photo_slider_btn} ${styles.vk_photo_slider_btn_prev} vk-photo-prev-${postIndex}`}>
                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M5.5 1L2 4L5.5 7" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                              </div>
                              <div className={styles.vk_photo_slider_counter}>
                                <span className={`vk-photo-counter-${postIndex}`}>1</span>
                                <span className={styles.vk_photo_slider_counter_sep}>/</span>
                                <span className={styles.vk_photo_slider_counter_total}>{postPhotos.length}</span>
                              </div>
                              <div className={`${styles.vk_photo_slider_btn} ${styles.vk_photo_slider_btn_next} vk-photo-next-${postIndex}`}>
                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.5 1L8 4L4.5 7" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                              </div>
                            </div>
                          </Swiper>
                        </div>
                      )}

                      {/* Текст поста — после фото/видео */}
                      {post.text && (
                        <div className={styles.vk_post_text}>
                          {post.text}
                        </div>
                      )}

                      {/* Статистика */}
                      {post.stats && (
                        <div className={styles.vk_stats}>
                          <div className={styles.vk_stat_item}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" fill="currentColor"/>
                            </svg>
                            <span>{post.stats.likes}</span>
                          </div>
                          <div className={styles.vk_stat_item}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="currentColor"/>
                            </svg>
                            <span>{post.stats.views}</span>
                          </div>
                          <div className={styles.vk_stat_item}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17 16L21 12L17 8V11H9V13H17V16ZM7 8L3 12L7 16V13H15V11H7V8Z" fill="currentColor"/>
                            </svg>
                            <span>{post.stats.reposts}</span>
                          </div>
                          <div className={styles.vk_stat_item}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="currentColor"/>
                            </svg>
                            <span>{post.stats.comments}</span>
                          </div>
                        </div>
                      )}
                    </div>
                    )
                  })}
                </div>
              </div>
            )}

            <WhiteBlockTitle
              title={data?.pagetitle}
              text={``}
            />
            <div className={styles.swiper_container}>
              <Swiper
                ref={this.swiperRef}
                modules={[Navigation]}
                spaceBetween={10}
                slidesPerView={2}
                loop={true}
                onSlideChange={this.handleSlideChange}
                onSwiper={(swiper) => {
                  this.setState({ activeIndex: swiper.realIndex })
                }}
                breakpoints={{
                  992: {
                    slidesPerView: 3
                  },
                  1202: {
                    slidesPerView: 4
                  }
                }}
              >
                {data?.list.map((slyde, index) => (
                  <SwiperSlide key={index}>
                    <div className={styles.slyde}>
                      <Image
                        className={styles.slyde_image}
                        src={slyde?.image}
                        width={288}
                        height={173}
                        alt={slyde?.name}
                        onClick={() => this.openLightbox(index)}
                        style={{cursor: 'pointer'}}
                      />
                      <div className={styles.slyde_content}>
                        <div className={styles.slyde_name}>{slyde?.name}</div>
                        <div className={styles.slyde_introtext}>{slyde?.introtext}</div>
                        <GreenButton
                          text={`Читать дальше`}
                          width={258}
                          addClass={`white`}
                          className={styles.slyde_btn}
                          href={slyde?.href}
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className={styles.slydenav_btns}>
                <div></div>
                <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                  </svg>
                </div>
              </div>
            </div>

            <UslugiLastCard
              assets_path={assets_path}
            />
          </div>
        </Container>

        {/* Модальное окно для поста VK */}
        {activePost && (
          <div className={styles.vk_post_modal} onClick={this.closePostModal}>
            <div className={styles.vk_post_modal_content} onClick={(e) => e.stopPropagation()}>
              <button className={styles.vk_post_modal_close} onClick={this.closePostModal}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>

              {/* Дата */}
              <div className={styles.vk_post_modal_date}>
                {this.formatDate(activePost.date)}
              </div>

              {/* Полный текст */}
              {activePost.text && (
                <div className={styles.vk_post_modal_text}>
                  {activePost.text}
                </div>
              )}

              {/* Все вложения в полном размере */}
              {activePost.attachments && activePost.attachments.length > 0 && (
                <div className={styles.vk_post_modal_attachments}>
                  {activePost.attachments.map((att, attIndex) => (
                    <div key={attIndex} className={styles.vk_post_modal_attachment}>
                      {(att.type === 'video' || att.type === 'short_video') && (
                        <div
                          className={styles.vk_post_modal_video_wrapper}
                          onClick={() => this.openVideo(att.player_url)}
                        >
                          <img
                            className={styles.vk_post_modal_video_preview}
                            src={att.preview || att.first_frame}
                            alt={att.title || 'Видео'}
                          />
                          <div className={styles.vk_post_modal_video_overlay}>
                            <div className={styles.vk_post_modal_video_play_btn}>
                              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="24" cy="24" r="24" fill="rgba(0,0,0,0.6)"/>
                                <path d="M20 16L32 24L20 32V16Z" fill="white"/>
                              </svg>
                            </div>
                          </div>
                        </div>
                      )}
                      {att.type === 'photo' && att.preview && (
                        <img
                          className={styles.vk_post_modal_photo}
                          src={att.preview}
                          alt="Фото"
                        />
                      )}
                      {att.type === 'link' && (
                        <a
                          href={att.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.vk_post_modal_link}
                        >
                          {att.preview && (
                            <img
                              className={styles.vk_post_modal_link_image}
                              src={att.preview}
                              alt={att.title || 'Ссылка'}
                            />
                          )}
                          <div className={styles.vk_post_modal_link_content}>
                            <div className={styles.vk_post_modal_link_title}>{att.title || ''}</div>
                            <div className={styles.vk_post_modal_link_desc}>{att.description || ''}</div>
                          </div>
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Статистика */}
              {activePost.stats && (
                <div className={styles.vk_post_modal_stats}>
                  <div className={styles.vk_post_modal_stat_item}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" fill="currentColor"/>
                    </svg>
                    <span>{activePost.stats.likes}</span>
                  </div>
                  <div className={styles.vk_post_modal_stat_item}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="currentColor"/>
                    </svg>
                    <span>{activePost.stats.views}</span>
                  </div>
                  <div className={styles.vk_post_modal_stat_item}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17 16L21 12L17 8V11H9V13H17V16ZM7 8L3 12L7 16V13H15V11H7V8Z" fill="currentColor"/>
                    </svg>
                    <span>{activePost.stats.reposts}</span>
                  </div>
                  <div className={styles.vk_post_modal_stat_item}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="currentColor"/>
                    </svg>
                    <span>{activePost.stats.comments}</span>
                  </div>
                </div>
              )}

              {/* Ссылка на пост в VK */}
              {activePost.url && (
                <div className={styles.vk_post_modal_vk_link_wrapper}>
                  <a
                    href={activePost.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.vk_post_modal_vk_link}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 17L17 7M17 7H11M17 7V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Открыть в VK
                  </a>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Модальное окно для видео */}
        {activeVideo && (
          <div className={styles.vk_video_modal} onClick={this.closeVideo}>
            <div className={styles.vk_video_modal_content} onClick={(e) => e.stopPropagation()}>
              <button className={styles.vk_video_close} onClick={this.closeVideo}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
              <iframe
                src={activeVideo}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="autoplay; encrypted-media; fullscreen"
                allowFullScreen
                title="VK Video"
              />
            </div>
          </div>
        )}

        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Stati.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Stati.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Stati
